var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("buttons-text", {
    attrs: { label: _vm.label, color: _vm.color, small: _vm.small },
    on: {
      clicked: function ($event) {
        return _vm.$emit("clicked", $event)
      },
    },
    scopedSlots: _vm._u(
      [
        _vm.iconLeft
          ? {
              key: "icon-left",
              fn: function () {
                return [
                  _c("v-icon", { attrs: { small: _vm.small } }, [
                    _vm._v(_vm._s(_vm.icon)),
                  ]),
                ]
              },
              proxy: true,
            }
          : null,
        _vm.iconRight
          ? {
              key: "icon-right",
              fn: function () {
                return [
                  _c("v-icon", { attrs: { small: _vm.small } }, [
                    _vm._v(_vm._s(_vm.icon)),
                  ]),
                ]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }